import FormErrorAttribute from 'types/FormErrorAttribute';

export interface ErrorData {
  Header: FormErrorAttribute;
  Rate: FormErrorAttribute;
  FromDate: FormErrorAttribute;
  EndDate: FormErrorAttribute;
}

export const CreateEmptyErrorData = () => {
  return {
    Header: {} as FormErrorAttribute,
    Rate: {} as FormErrorAttribute,
    FromDate: {} as FormErrorAttribute,
    EndDate: {} as FormErrorAttribute,
  } as ErrorData;
};
